var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({attrs:{"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
var navigate = ref.navigate;
return [_c('li',{staticClass:"nav-item",class:{ active: _vm.exact ? isExactActive : isActive },on:{"click":navigate}},[_c('a',_vm._b({staticClass:"nav-link"},'a',{ href: href },false),[_c('i',{staticClass:"far fa-fw",class:("fa-" + _vm.icon)}),_c('span',[_vm._t("default")],2)])])]}}],null,true)},'router-link',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }